module.exports = __webpack_public_path__ + "img/AzadBarzinji-Awrishim.1de9f4ba.jpg";